import { Document, Packer, Paragraph, TextRun, Table, TableCell, TableRow, AlignmentType, VerticalAlign, WidthType } from "docx";
import { saveAs } from "file-saver";

const exportWord = async (content, title) => {
    let arr = [];
    content.map(item => {
        let paragraph = new Paragraph({
            children: [
                new TextRun(item),
            ],
            spacing: {
                line: 240, // 设置行间距，1.5倍行距为 240
                before: 200, // 段前间距
                after: 200, // 段后间距
            },
        })
        arr.push(paragraph)
    })
    console.log(arr)
    // 创建一个新的文档对象
    const doc = new Document({
        sections: [
            {
                properties: {},
                children: arr
            },
        ],
    });

    // 使用 Packer 打包文档
    const buffer = await Packer.toBlob(doc);

    // 使用 file-saver 保存文件
    saveAs(buffer, title);
}
const exportWordAndExcel = async (content, title) => {
    let arr = [];
    content.map(item => {
        let paragraph = new Paragraph({
            children: [
                new TextRun(item.q_title),
            ],
            spacing: {
                line: 240, // 设置行间距，1.5倍行距为 240
                before: 200, // 段前间距
                after: 200, // 段后间距
            },
        })
        arr.push(paragraph);
        if (item.q_type == 3) {
            let rows = [
                new TableRow({
                    height: {
                        value: 500, // 设置行高，单位是twips
                        rule: "exact", // 使用精确行高
                    },
                    children: [
                        new TableCell({
                            children: [new Paragraph("选项")],
                            width: {
                                size: 8000, // 设置宽度，单位是twips (1/20 pt)，4000 twips ≈ 200 pt
                                type: WidthType.DXA, // DXA是Word使用的单位
                            },
                            shading: {
                                fill: "F5F5F5", // 设置背景颜色 (浅蓝色)
                            },
                            verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                            children: [new Paragraph("小计")],
                            width: {
                                size: 2000, // 设置宽度，单位是twips (1/20 pt)，4000 twips ≈ 200 pt
                                type: WidthType.DXA, // DXA是Word使用的单位
                            },
                            shading: {
                                fill: "F5F5F5", // 设置背景颜色 (浅蓝色)
                            },
                            verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                            children: [new Paragraph("比例")],
                            width: {
                                size: 8000, // 设置宽度，单位是twips (1/20 pt)，4000 twips ≈ 200 pt
                                type: WidthType.DXA, // DXA是Word使用的单位
                            },
                            shading: {
                                fill: "F5F5F5", // 设置背景颜色 (浅蓝色)
                            },
                            verticalAlign: VerticalAlign.CENTER,
                        }),
                    ],
                }),
            ];
            item.items.map(option=>{
                rows.push(new TableRow({
                    children: [
                        new TableCell({
                            children: [new Paragraph(option.item_title)],
                        }),
                        new TableCell({
                            children: [new Paragraph(option.item_selected_count?option.item_selected_count.toFixed():'0')],
                        }),
                        new TableCell({
                            children: [new Paragraph(option.item_selected_count?(option.item_selected_count/item.q_count*100).toFixed(2)+'%':'0%')],
                        }),
                    ],
                }))
            })
            // 创建表格
            let table = new Table({
                rows
            })
            arr.push(table)
        }
    })
    // 创建一个新的文档对象
    const doc = new Document({
        sections: [
            {
                properties: {},
                children: arr
            },
        ],
    });

    // 使用 Packer 打包文档
    const buffer = await Packer.toBlob(doc);

    // 使用 file-saver 保存文件
    saveAs(buffer, title);
}
export { exportWord, exportWordAndExcel };